interface LevelUpFlashProps {
  show: boolean;
  level: number;
}

export default function LevelUpFlash({ show, level }: LevelUpFlashProps) {
  if (!show) return null;

  return (
    <div className="level-up-flash">
      <div
        className="rounded-[16px] p-8 text-center"
        style={{ background: 'linear-gradient(180deg,#f96a55,#ffcc00 45%,#36d9d3)' }}
      >
        <p className="font-heading text-lg text-white">LEVEL UP!</p>
        <p className="font-grotesk font-bold text-3xl text-white mt-2">LEVEL {level}</p>
      </div>
    </div>
  );
}
